import {
  CREATE_STORYBOARD_LIST_REQUEST, CREATING_STORYBOARD_LIST_SUCCEEDED, CREATING_STORYBOARD_LIST_FAILED,
  FETCH_STORYBOARD_LIST_REQUEST, FETCHING_STORYBOARD_LIST_SUCCEEDED, FETCHING_STORYBOARD_LIST_FAILED,
  UPDATING_STORYBOARD_LIST_REQUEST, UPDATING_STORYBOARD_LIST_SUCCEEDED, UPDATING_STORYBOARD_LIST_FAILED,
  ADDING_STORYBOARD_TO_LIST_REQUEST, ADDING_STORYBOARD_TO_LIST_SUCCEEDED, ADDING_STORYBOARD_TO_LIST_FAILED,
  DELETE_STORYBOARD_LIST_REQUEST, DELETING_STORYBOARD_LIST_SUCCEEDED, DELETING_STORYBOARD_LIST_FAILED,
  SHOW_STORYBOARD_LIST_CREATE_FORM, INVALIDATE_STORYBOARD_LIST,
  SELECT_STORYBOARD_LIST, INVALIDATE_ADD_STORYBOARD,
  REMOVING_STORYBOARD_FROM_LIST, REMOVING_STORYBOARD_FROM_LIST_SUCCEEDED, REMOVING_STORYBOARD_FROM_LIST_FAILED
} from 'constants/actionTypes';

import _ from 'lodash';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { createAction } from 'redux-actions';
import buildUrl from 'build-url';

const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const STORYBOARD_LIST_URL = `${apiUrl}/api/1.0/storyboards/list`;

/**
 * Fetch All storyboard Lists for user
*/
export const fetchAllStoryboardLists = createAction(FETCH_STORYBOARD_LIST_REQUEST, () => {
  return;
})

export const fetchAllStoryboardListstSucceeded = createAction(FETCHING_STORYBOARD_LIST_SUCCEEDED, (response) => {
  return response;
})

export const fetchAllStoryboardListsFailed = createAction(FETCHING_STORYBOARD_LIST_FAILED, (error) => {
  return error;
})

function* fetchAllStoryboardListsSaga(action) {

  const fetchAllStoryboardListsAPI = () => {
    return axios.get(STORYBOARD_LIST_URL).then(response => response.data);
  }

  try {
    const response = yield call(fetchAllStoryboardListsAPI);
    if (response) {
      yield put(fetchAllStoryboardListstSucceeded(response));
    }
  } catch (error) {
    yield put(fetchAllStoryboardListsFailed(error));
  }
}


/**
 * Create storyboard List for user
*/
export const createNewStoryboardList = createAction(CREATE_STORYBOARD_LIST_REQUEST, (request) => {
  return {
    request: request
  };
})

export const createNewStoryboardListSucceeded = createAction(CREATING_STORYBOARD_LIST_SUCCEEDED, (response) => {
  return response;
})

export const createNewStoryboardListFailed = createAction(CREATING_STORYBOARD_LIST_FAILED, (error) => {
  return error;
})

function* createNewStoryboardListSaga(action) {
  const { request } = action.payload;

  const createNewStoryboardListAPI = () => {
    return axios.post(STORYBOARD_LIST_URL, request).then(response => response.data);
  }

  try {
    const response = yield call(createNewStoryboardListAPI);
    if (response) {
      yield put(createNewStoryboardListSucceeded(response));
    }
  } catch (error) {
    yield put(createNewStoryboardListFailed(error));
  }
}

/**
 * update Storyboard List
*/
export const updateStoryboardList = createAction(UPDATING_STORYBOARD_LIST_REQUEST, (id, request) => {
  return {
    id: id,
    request: request
  };
})

export const updateStoryboardListSucceeded = createAction(UPDATING_STORYBOARD_LIST_SUCCEEDED, (response) => {
  return response;
})

export const updateStoryboardListFailed = createAction(UPDATING_STORYBOARD_LIST_FAILED, (error) => {
  return error;
})

function* updateStoryboardListSaga(action) {
  var { id, request } = action.payload;

  const url = buildUrl(STORYBOARD_LIST_URL, {
    path: `/${id}`
  });

  const updateStoryboardListApi = () => {
    return axios.put(url, request).then(response => response.data);
  }

  try {
    const response = yield call(updateStoryboardListApi);
    if (response) {
      yield put(updateStoryboardListSucceeded(response));
    }
  } catch (error) {
    yield put(updateStoryboardListFailed(error));
  }
}

/**
 * Delete Storyboard List
 * 
*/
export const deleteStoryboardList = createAction(DELETE_STORYBOARD_LIST_REQUEST, (id) => {
  return {
    id: id,
  }
})

export const deletingStoryboardListSucceeded = createAction(DELETING_STORYBOARD_LIST_SUCCEEDED, (response) => {
  return response;
})

export const deletingStoryboardListFailed = createAction(DELETING_STORYBOARD_LIST_FAILED, (id, error) => {
  return { id, error };
})

function* deleteStoryboardListSaga(action) {
  const { id } = action.payload;

  const url = buildUrl(STORYBOARD_LIST_URL, {
    path: `/${id}`
  });

  const deleteFontAPI = () => {
    return axios.delete(url).then(response => response.data);
  }

  try {
    const response = yield call(deleteFontAPI);
    yield put(deletingStoryboardListSucceeded(response));
  } catch (error) {
    yield put(deletingStoryboardListFailed(id, error));
  }
}

/**
* Adding storyboard to List
*/
export const addStoryboardToList = createAction(ADDING_STORYBOARD_TO_LIST_REQUEST, (source, target, storyboard) => {
  return {
    source: source,
    target: target,
    storyboard: storyboard
  };
})

export const addStoryboardToListSucceeded = createAction(ADDING_STORYBOARD_TO_LIST_SUCCEEDED, (source, target, storyboard) => {
  return {
    source: source,
    target: target,
    storyboard: storyboard
  };
})

export const addStoryboardToListFailed = createAction(ADDING_STORYBOARD_TO_LIST_FAILED, (target, error) => {
  return {
    target: target,
    error: error
  };
})

function* addStoryboardToListSaga(action) {
  const { source, target, storyboard } = action.payload;

  var request = [storyboard.id];

  let url = buildUrl(STORYBOARD_LIST_URL, {
    path: `/${target.id}/storyboards`
  });

  const addStoryboardToListAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(addStoryboardToListAPI);
    const sourceList = yield select(state => {
      const lists = _.get(state, 'storyboardList.items') || [];
      return lists.find(item => item.id === source);
    });
    
    yield put(addStoryboardToListSucceeded(sourceList, target, storyboard));
    if(sourceList) {
      yield put(removeStoryboardFromList(storyboard.id,  sourceList.id))
    }
  } catch (error) {
    yield put(addStoryboardToListFailed(target.id, error));
  }
}


/**
 * Remove Storyboard from List
*/
export const removeStoryboardFromList = createAction(REMOVING_STORYBOARD_FROM_LIST, (storyboardId, listId) => {
  return {
    storyboardId: storyboardId,
    listId: listId
  }
})

const removeStoryboardFromListSucceeded = createAction(REMOVING_STORYBOARD_FROM_LIST_SUCCEEDED, (id, response) => {
  return {
    storyboardId: id,
    response: response
  }
})

const removeStoryboardFromListFailed = createAction(REMOVING_STORYBOARD_FROM_LIST_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* removeStoryboardFromListSaga(action) {
  const { storyboardId, listId } = action.payload;

  var params = {
    storyboardId: storyboardId
  }

  let url = buildUrl(STORYBOARD_LIST_URL, {
    path: `${listId}/storyboards`,
  });

  const removeStoryboardListAPI = () => {
    return axios({
      method: 'DELETE',
      url: url,
      params: params
    }).then(response => response.data);
  }

  try {
    const response = yield call(removeStoryboardListAPI);
    yield put(removeStoryboardFromListSucceeded(storyboardId, response));
  } catch (error) {
    yield put(removeStoryboardFromListFailed(storyboardId, error));
  }
}

/**
 * Show Storyboard List
*/
export const showStoryboardListCreateForm = createAction(SHOW_STORYBOARD_LIST_CREATE_FORM);

/**
 * Invalidate Storyboard List
*/
export const invalidateStoryboardList = createAction(INVALIDATE_STORYBOARD_LIST);


/**
 * Invalidate Add Storyboard
*/
export const invalidateAddStoryboard = createAction(INVALIDATE_ADD_STORYBOARD);

/**
 * Select Storyboard List
*/
export const selectStoryboardList = createAction(SELECT_STORYBOARD_LIST, (id) => {
  return {
    id: id
  };
})

export default function* storyboardListSaga() {
  yield takeEvery(FETCH_STORYBOARD_LIST_REQUEST, fetchAllStoryboardListsSaga);
  yield takeEvery(CREATE_STORYBOARD_LIST_REQUEST, createNewStoryboardListSaga);
  yield takeEvery(UPDATING_STORYBOARD_LIST_REQUEST, updateStoryboardListSaga);
  yield takeEvery(DELETE_STORYBOARD_LIST_REQUEST, deleteStoryboardListSaga);
  yield takeEvery(ADDING_STORYBOARD_TO_LIST_REQUEST, addStoryboardToListSaga);
  yield takeEvery(REMOVING_STORYBOARD_FROM_LIST, removeStoryboardFromListSaga);
}